import React from 'react'
import LanguageSelector from './components/LanguageSelector/LanguageSelector';
import NotificationsBar from './components/NotificationsBar/NotificationsBar';
import UserInfo from './components/UserInfo/UserInfo';

import './TopBar.scss';

const TopBar = () => {
    return (
        <div className='TopBar'>
            <div className='TopBar__flexEnd'>
                <LanguageSelector />
                <NotificationsBar />
            </div>           

            <UserInfo />
        </div>
    );
}

export default TopBar;
